import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import userIcon from '../images/profile.png';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  //const location = useLocation();
  const [darkMode, setDarkMode] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
    document.body.classList.toggle('dark', !darkMode);
  };

  // if (location.pathname === '/login') {
  //   return null;
  // }

  return (
    <nav className="bg-blue-600/80 dark:bg-gray-900 text-white shadow-lg hidden-print">
      <div className="container mx-auto flex justify-between items-center p-4">
        <div className="text-2xl font-bold cursor-pointer">DockPay</div>
        {/* Desktop Links */}
        <ul className="hidden md:flex space-x-8">
          <li><a href="/form" className="hover:text-gray-300 font-bold">Home</a></li>
          <li><a href="/history" className="hover:text-gray-300 font-bold">History</a></li>
          {user && (
            <li>
              <button
                onClick={handleLogout}
                className="hover:text-red-400 font-bold"
              >
                Logout
              </button>
            </li>
          )}
        </ul>

        {/* Right Controls */}
        <div className="flex items-center gap-4">
          {/* <img 
          src={darkMode ? sunIcon : moonIcon} 
          alt="Toggle Dark Mode" 
          className="w-8 h-8 cursor-pointer"
          onClick={toggleDarkMode}
        /> */}
          <Link to="/profile">
            <img
              src={userIcon}
              alt="User Profile"
              className="w-10 h-10 rounded-full border-2 border-white"
            />
          </Link>
          {/* Mobile Menu Button */}
          <button
            className="md:hidden focus:outline-none"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            ☰
          </button>
        </div>
      </div>

      {/* Mobile Dropdown Menu */}
      {menuOpen && (
        <div className="md:hidden flex flex-col items-center bg-blue-500/80 dark:bg-gray-800 py-2 border-t border-b border-white w-full">
          <a href="/form" className="hover:text-gray-300 font-bold w-full text-center border-white pb-2 last:border-b-0">
            Home
          </a>
          <a href="/history" className="hover:text-gray-300 font-bold w-full text-center border-t border-white pb-2 last:border-b-0">
            History
          </a>
          {user && (
            <button
              onClick={handleLogout}
              className="hover:text-red-400 font-bold w-full text-center border-t border-white  last:border-b-0"
            >
              Logout
            </button>
          )}
        </div>
      )}

    </nav>

  );
};

export default Navbar;
